<template>
  <div class="pl-24 pr-24">
    <div class="pointer" v-show="!show_assignations" @click="toggle(true)">
      <span class="text-large mr-16">+</span><span class="text-large">Assigning in agenda</span>
    </div>
    <div v-show="show_assignations">
      <div class="flex pointer" @click="toggle(false)">
        <div class="heading-medium w-100">Assigning in agenda</div>
        <div class="heading-medium text-right assignations-hide pointer" @click="toggle(false)">
          <div class="assignations-tooltip">Remove assignments</div>
          -
        </div>
      </div>
      <div class="mt-16">
        <table class="assignations-table">
          <tr>
            <th>Date in agenda</th>
            <th>Assignee</th>
            <th>Assigned hours</th>
            <th></th>
          </tr>
          <tr v-for="assignation in assignations" :key="assignation.id" v-if="!assignation.deleted">
            <td>
              <date-picker
                @dateSelected="assignation.date = $event"
                :dateFormat="'dd M yyyy'"
                :defaultDate="assignation.date"
                @blur="$v.assignation.date.$touch()"></date-picker>
            </td>
            <td>
              <select class="form-control" v-model="assignation.user_id">
                <option :value="user.id" v-for="user in users">{{ user.name }}</option>
              </select>
            </td>
            <td>
              <input type="text" class="form-control" v-model="assignation.duration">
            </td>
            <td>
              <div @click="removeAssignation(assignation.id)">
                <svg-trash-can></svg-trash-can>
              </div>
            </td>
          </tr>
        </table>
        <div class="mt-16 flex">
          <div class="pointer underline" @click="addAssignation()">+ Assign another</div>
          <div class="flex-grow-1 text-right">Assigned of planned hours: {{ _total_assignation_hours }} / {{ duration }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import DatePicker from "../../../components/partials/Datepicker";

let newAssignation = {
  user_id: null,
  date: moment().format('DD MMM YYYY'),
  duration: '01:00',
}

export default {
  props: {
    duration: {},
    users: {},
    value: {},
  },
  components: {
    DatePicker,
  },
  created() {
    this.$root.$on('Assignations::add', (data) => {
      this.addAssignation(data)

    })
    this.$root.$on('Assignations::clear', () => {
      this.assignations = []
    })
    this.$root.$on('Assignations::new', (data) => {
      this.assignations = []
      this.addAssignation(data)
    })
    this.$root.$on('Assignations::open', () => this.toggle(true))
    this.$root.$on('Assignations::close', () => this.toggle(false))
  },
  data() {
    return {
      assignations: [],
      show_assignations: false,
    }
  },
  watch: {
    'assignations': {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true,
    }
  },
  computed: {
    _total_assignation_hours() {
      let integerSeconds = _.map(this.assignations, assignation => {
        return this.$root.formatTimestringToIntegerSeconds(assignation.duration)
      })
      integerSeconds = _.sum(integerSeconds)

      return this.$root.secondsToTimestring(integerSeconds)
    }
  },
  methods: {
    toggle(show) {
      this.show_assignations = show
      if (!show) {
        // this.assignations = []
      } else {
        if (this.assignations.length == 0) {
          this.addAssignation({})
        }
      }
    },
    addAssignation(data) {
      let assignation = _.clone(newAssignation)
      assignation.id = 'new-' + _.uniqueId()
      _.each(data, (value, key) => {
        if (key === 'date') {
          value = moment(value).format('DD MMM YYYY')
        }
        assignation[key] = value
      })
      this.assignations.push(assignation)
    },
    removeAssignation(id) {
      let assignation = _.find(this.assignations, a => a.id === id)
      if (_.isString(assignation.id) && assignation.id.lastIndexOf('new-', 0) === 0) {
        this.assignations = _.reject(this.assignations, a => a.id === id)
      } else {
        this.$set(assignation, 'deleted', true)
      }
    }
  }
}
</script>
<style lang="scss">
  .underline {
    &:hover {
      text-decoration: underline;
    }
  }
  .assignations-hide {
    position:relative;
    min-width: 20px;
    text-align: center;

    .assignations-tooltip {
      display: none;
      position: absolute;
      bottom: 20px;
      background: #4D4D4D;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
      border-radius: 8px;
      color: white;
      width: max-content;
      padding: 4px 8px;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 130%;
      left: 50%;
      transform: translateX(-50%);
    }
    &:hover {
      .assignations-tooltip {
        //display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-modal/assignations.vue